interface IIconProps {
  size?: number;
  color?: string;
}

const TopThreeFinishesIcon = ({ size, color }: IIconProps) => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="32" height="32" rx="3.2" fill="url(#paint0_linear_1341_28383)"/>
<rect x="4.78" y="4.78" width="30.44" height="30.44" rx="2.42" stroke="url(#paint1_linear_1341_28383)" strokeWidth="1.56"/>
<g clipPath="url(#clip0_1341_28383)">
<path d="M19.6205 22.9557C16.8221 22.9557 14.5439 20.6776 14.5439 17.8792C14.5439 15.0779 16.8221 12.7998 19.6205 12.7998C22.4189 12.7998 24.6971 15.0779 24.6971 17.8764C24.6971 20.6776 22.4189 22.9557 19.6205 22.9557ZM19.6205 15.1651C18.1243 15.1651 16.9064 16.3829 16.9064 17.8792C16.9064 19.3754 18.1243 20.5904 19.6205 20.5904C21.1168 20.5904 22.3346 19.3726 22.3346 17.8792C22.3346 16.3801 21.1168 15.1651 19.6205 15.1651Z" fill="white"/>
<path d="M15.1332 21.3643L12.8691 25.2089L14.9898 25.4761L16.2498 27.2002L18.497 23.3864C17.057 23.1896 15.9432 22.5033 15.1332 21.3643Z" fill="white"/>
<path d="M24.067 21.3643L26.3339 25.2089L24.2132 25.4761L22.9532 27.2002L20.7061 23.3864C22.1432 23.1896 23.257 22.5033 24.067 21.3643Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_1341_28383" x1="20" y1="4" x2="20" y2="36" gradientUnits="userSpaceOnUse">
<stop stopColor="#A5DEEE"/>
<stop offset="1" stopColor="#39B8DB"/>
</linearGradient>
<linearGradient id="paint1_linear_1341_28383" x1="13.0177" y1="15.8519" x2="25.1746" y2="25.1017" gradientUnits="userSpaceOnUse">
<stop stopColor="#59D1F2"/>
<stop offset="0.429043" stopColor="#97E9FF"/>
<stop offset="1" stopColor="#39B8DB"/>
</linearGradient>
<clipPath id="clip0_1341_28383">
<rect width="14.4" height="14.4" fill="white" transform="translate(12.4004 12.7998)"/>
</clipPath>
</defs>
</svg>

);

TopThreeFinishesIcon.defaultProps = {
  size: 46,
  color: 'currentColor',
};

export default TopThreeFinishesIcon;
